import { PermissionT } from "../types";

export const rsmAuthority = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "rsm_authority");
  return !!p;
};

export default rsmAuthority;
